import { API_URL } from '@/api/constants'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import axios from 'axios'

export type AllCampaignQuizResults = {
  video_id: string
  quiz_results: CampaignVideoQuizResults
}[]

export type CampaignVideoQuizResults = {
  question: string
  correct_answer: string
  score: number
  total_answered: number
  correct_answered: number
}[]

const getCampaignQuizResults = async (id: string) => {
  const url = `${API_URL}/campaigns/${id}/quiz-results/`
  const { data } = await axios.get(url, { withCredentials: true })

  return data.reduce((acc: any, item: any) => {
    acc[item.video_id] = item.quiz_results
    return acc
  }, {} as Record<string, CampaignVideoQuizResults>)
}

export const useCampaignQuizResults = (id: string, enabled: boolean = true) => {
  return useQuery<Record<string, CampaignVideoQuizResults>>({
    queryKey: ['campaignQuizResults', id],
    queryFn: () => getCampaignQuizResults(id),
    placeholderData: keepPreviousData,
    enabled,
  })
}
